module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ai6aV"))).then(() => parcelRequire('37nVf'));